import type { FC } from "react";
import type { Path } from "react-hook-form";
import type { EmailDesignSchema } from "../../email-design/types/email-design-type";
import { CeColourField } from "../../generic/components/form-fields/ce-colour-field";
import { CeDropdown } from "../../generic/components/form-fields/ce-dropdown";
import { CeSlider } from "../../generic/components/form-fields/ce-slider";
import { FormStack } from "../../generic/components/form-fields/form-stack";

const DividerSettingsEditor: FC<{ type: "primary" | "secondary" }> = ({ type }) => {
  const name: Path<EmailDesignSchema> = `divider_settings.${type}`;
  return (
    <FormStack>
      <CeColourField<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.color`}
        label="Color"
      />
      <CeSlider<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.width`}
        label="Width"
        min={1}
        max={10}
        step={1}
      />
      <CeDropdown<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.style`}
        label="Style"
        options={[
          { label: "Solid", value: "solid" },
          { label: "Dashed", value: "dashed" },
          { label: "Dotted", value: "dotted" },
        ]}
      />
    </FormStack>
  );
};

export const PrimaryDividerSettingsEditor: FC = () => <DividerSettingsEditor type="primary" />;
export const SecondaryDividerSettingsEditor: FC = () => <DividerSettingsEditor type="secondary" />;
